import appLayout from '../layouts/AppLayout.vue'
export default [
  {
    path: '/insurances/search/kudenix',
    name: 'insurance-kudenix',
    component: () => import(/* webpackChunkName: "insurance-kudenix" */ '../views/insurance/kudenix/index.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/insurance/reserve/kudenix',
    name: 'insurance-reserve-kudenix',
    component: () => import(/* webpackChunkName: "insurance-reserve-kudenix" */ '../views/insurance/kudenix/reserve.vue'),
    meta: { layout: appLayout }
  }
]
